export default `
mutation updateCartWalletDiscount($input:updateCartWalletDiscountInput!) { 
    updateCartWalletDiscount(input:$input){ 
       cart{
           id
       }
    }
}
`;
